import { UserClassroomItem, IBannerListItem, RegionList, PracticalItem } from '@/interface'
// import { IPageData } from '~/typings'
import {
  getClassroomList,
  ICertificateClassroomQuery,
  getCertificationOfClassroom,
  getPracticalExamList
} from '@/request/api/classroom'
import {
  getRegionListBySiteId,
  getLanguageBySiteId,
  getCertificationWithPracticalExam
} from '@/request/api/common'
// import { getBannerInfo } from '@/request/api/common'
import { Commit } from 'vuex'

const state = {
  classroomList: [] as UserClassroomItem[],
  practicalExamList: [] as PracticalItem[],
  classroomBanner: [] as IBannerListItem[],
  classroomDetail: {} as UserClassroomItem,
  languageList: [] as string[],
  certificationList: [] as Array<{ certificationName: string, id: number }>,
  regionList: [] as RegionList[],
  loading: false,
  fetchingData: false,
  classroomListLoading: true,
  tabDisplay: true,
  classroomListPageTabValue: '0'
}

export type ClassroomState = typeof state

const classroomStore = {
  namespaced: true,
  state,
  actions: {
    async getClassroomList ({ commit }: { commit: Commit }, payload: ICertificateClassroomQuery) {
      commit('setClassroomList', [])
      const res = await getClassroomList(payload)
      commit('setClassroomList', (res?.data || []) as UserClassroomItem[])
    },
    async getPracticalExamList ({ commit }: { commit: Commit }, payload: ICertificateClassroomQuery) {
      commit('setPracticalExamList', [])
      const res = await getPracticalExamList(payload)
      commit('setPracticalExamList', (res?.data || []) as PracticalItem[])
    },
    async checkTabDisplay ({ commit }: { commit: Commit }, payload: { kind: string }) {
      const res = await getPracticalExamList(payload)
      commit('setTabDisplay', ((res?.data as PracticalItem[]) || []).length > 0)
    },
    async getCertificationOfClassroom ({ commit }: { commit: Commit }, payload: { kind: string }) {
      const res = await getCertificationOfClassroom(payload)
      commit('setCertificationList', (res?.data || []) as any[])
    },
    async getRegionListBySiteId ({ commit }: { commit: Commit }) {
      const res = await getRegionListBySiteId()
      commit('setRegionList', (res?.data || []) as RegionList[])
    },
    async getLanguageList ({ commit }: { commit: Commit }) {
      const res = await getLanguageBySiteId()
      commit('setLanguageList', (res?.data || []) as string[])
    },
    async getCertificationWithPracticalExam ({ commit }: { commit: Commit }, payload: { kind: string }) {
      const res = await getCertificationWithPracticalExam(payload)
      commit('setCertificationList', (res?.data || []) as any[])
    }
  },
  mutations: {
    setClassroomList (state: ClassroomState, data: UserClassroomItem[]): void {
      state.classroomList = data
    },
    setPracticalExamList (state: ClassroomState, data: PracticalItem[]): void {
      state.practicalExamList = data
    },
    setClassroomBanner (state: ClassroomState, data: IBannerListItem[]): void {
      state.classroomBanner = data
    },
    setClassroomLoading (state: ClassroomState, loading: boolean): void {
      state.classroomListLoading = loading
    },
    setClassroomFetchingData (state: ClassroomState, loading: boolean): void {
      state.fetchingData = loading
    },
    setClassroomDetail (state: ClassroomState, detail: UserClassroomItem): void {
      state.classroomDetail = detail
    },
    setRegionList (state: ClassroomState, regionList: RegionList[]): void {
      state.regionList = regionList
    },
    setCertificationList (state: ClassroomState, certificationList: any[]): void {
      state.certificationList = certificationList
    },
    setLanguageList (state: ClassroomState, languageList: string[]): void {
      state.languageList = languageList
    },
    setTabValue (state: ClassroomState, value: string): void {
      state.classroomListPageTabValue = value
    },
    setTabDisplay (state: ClassroomState, value: boolean): void {
      state.tabDisplay = value
    }
  }
}

export {
  classroomStore
}
